
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type relatedItemsRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function relatedItemsRT(): TemplateResult<relatedItemsRTRootProps> {
    function repeatItems1(items, itemsIndex) {
        return [items(function () {
                function repeatBadge1(isTireProduct, isStoreSelected, isEconomyBrand, badge, badgeIndex) {
                    return [_createElement('span', {
                            'className': 'product-label product-label--convermax cm_badge cm_badge__' + this.toKebabCase(badge),
                            'key': '9241'
                        }, '\n                ', badge, '\n              ')];
                }
                function scopePercentageDiscountInitialPriceDiscountInitialPrice2(isTireProduct, isStoreSelected, isEconomyBrand) {
                    var percentageDiscount = this.price * (this.percentage_discount || 0) / 100;
                    var initialPriceDiscount = percentageDiscount + (this.dollars_discount || 0) / 4;
                    var initialPrice = this.formatPrice(this.price - initialPriceDiscount);
                    return _createElement('div', {
                        'className': 'price titan-price',
                        'data-initial-price': initialPrice,
                        'data-initial-discount': initialPriceDiscount,
                        'data-regional-price': this.price,
                        'data-percentage-discount': percentageDiscount,
                        'data-dollars-discount': this.dollars_discount || 0,
                        'key': '35311'
                    }, _createElement('div', { 'className': 'titan-left-price' + (!isOnStaggeredSearch && initialPriceDiscount > 0 ? ' titan-price-green' : '') }, _createElement('strong', { 'className': 'titan-price-amount' }, initialPrice), _createElement('span', { 'className': 'titan-price-amount-label' }, 'EA.')), _createElement('div', { 'className': 'titan-right-price' + (initialPriceDiscount > 0 ? '' : ' cm_hide') }, _createElement('span', { 'className': 'titan-price-amount' }, this.formatPrice(this.price)), _createElement('span', { 'className': 'titan-price-amount-label' }, 'EA.')));
                }
                function repeatSaving3(isTireProduct, isStoreSelected, isEconomyBrand, saving, savingIndex) {
                    return _createElement('li', {
                        'key': saving,
                        'className': 'cm_discount-savings' + (isOnStaggeredSearch ? ' redX' : ' greenCheck')
                    }, '\n                ', saving, '\n              ');
                }
                function repeatSaving4(isTireProduct, isStoreSelected, isEconomyBrand, saving, savingIndex) {
                    return _createElement('li', {
                        'key': saving,
                        'className': isOnStaggeredSearch ? 'redX' : 'greenCheck'
                    }, '\n                ', saving, '\n              ');
                }
                function onClick5(isTireProduct, isStoreSelected, isEconomyBrand, e) {
                    {
                        isOnStaggeredSearch ? window.Convermax.addStaggeredPackagesHandler(this)(e) : null;
                    }
                }
                function scopeProduct6(isTireProduct, isStoreSelected, isEconomyBrand) {
                    var product = this.productData ?? this;
                    return [product.is_autosync_allowed ? _createElement('button', {
                            'className': 'cm_view-on-vehicle-btn btn cm_btn--secondary',
                            'onClick': () => window.Convermax.openAutoSyncDialog(product.autosync_id, product.autosync_mpn, product.FitmentType?.includes('Tire')),
                            'type': 'button',
                            'key': '121401'
                        }, '\n    ', _translate(`view_product_on_vehicle`), '\n  ') : null];
                }
                function scopeIsTireProductIsStoreSelectedIsEconomyBrand7() {
                    var isTireProduct = this.FitmentType?.includes('Tire');
                    var isStoreSelected = window.Convermax.isStoreSelected;
                    var isEconomyBrand = this.removeHTML(this.Brand) === 'Economy';
                    return _createElement('li', { 'className': 'w-full' }, _createElement('product-card', {
                        'id': 'titan-product-card-' + this.id,
                        'class': 'card card--product h-full relative flex flex-col md:flex-row items-center'
                    }, _createElement('div', { 'className': 'card__media flex flex-col' }, _createElement('div', { 'className': 'image-container' }, _createElement('a', {
                        'href': this.url,
                        'aria-label': this.removeHTML(this.title),
                        'tabIndex': '-1',
                        'className': 'block image-blend js-prod-link'
                    }, _createElement('img', {
                        'src': this.resizeImage(this.image || window.Convermax.getProductImage(this.FitmentType[0])),
                        'loading': 'lazy',
                        'alt': this.removeHTML(this.title),
                        'className': 'card__main-image no-js-hidden'
                    })), _createElement('div', { 'className': 'product-label-container absolute top-0 start' }, _createElement.apply(this, [
                        'div',
                        { 'className': 'product-label-wrapper flex' },
                        _map(this._badges, repeatBadge1.bind(this, isTireProduct, isStoreSelected, isEconomyBrand)),
                        this.custom_flag_text ? _createElement('span', {
                            'className': 'product-label product-label--convermax',
                            'key': '1168'
                        }, '\n              ', this.custom_flag_text, '\n            ') : null
                    ])), _createElement('div', { 'className': 'product-label-container product-label-container--bottom absolute bottom-0 start' }, _createElement('div', { 'className': 'product-label-wrapper flex' }, isEconomyBrand ? _createElement('span', {
                        'className': 'product-label product-label--online',
                        'key': '1507'
                    }, [_createElement('svg', {
                            'className': 'cm_icon cm_icon-monitor',
                            'width': '13',
                            'height': '12',
                            'viewBox': '0 0 13 12',
                            'fill': 'none',
                            'xmlns': 'http://www.w3.org/2000/svg',
                            'key': '15950'
                        }, _createElement('path', {
                            'd': 'M4 10.5H8.33333M6.16667 8.33333V10.5M1.83333 0.75H10.5C11.0983 0.75 11.5833 1.23502 11.5833 1.83333V7.25C11.5833 7.84831 11.0983 8.33333 10.5 8.33333H1.83333C1.23502 8.33333 0.75 7.84831 0.75 7.25V1.83333C0.75 1.23502 1.23502 0.75 1.83333 0.75Z',
                            'stroke': 'currentColor',
                            'strokeWidth': '1.5',
                            'strokeLinecap': 'round',
                            'strokeLinejoin': 'round'
                        }))], '\n              Online Appointment Only\n            ') : null)))), _createElement('div', { 'className': 'card__info-container flex flex-col flex-auto relative' }, _createElement('div', { 'className': 'card__info w-full' }, _createElement('div', { 'className': 'card__info-inner inline-block w-full mb-2' }, _createElement('p', { 'className': 'card__vendor text-sm text-theme-light' }, this.removeHTML(this.Brand)), _createElement('p', { 'className': 'card__title font-bold mb-1' }, _createElement('a', {
                        'href': this.url,
                        'className': 'card-link text-current js-prod-link'
                    }, '\n              ', this.removeHTML(`${ this.etail_model ?? this.title }`), '\n            ')), _createElement('p', { 'className': 'card__size rte' }, !isTireProduct ? [
                        '\n              ',
                        this.removeHTML(this.wheel_size),
                        '\n              ',
                        this.wheel_finish ? [
                            ' | ',
                            this.removeHTML(this.wheel_finish)
                        ] : null
                    ] : null, isTireProduct ? [
                        '\n              ',
                        this.removeHTML(this.tire_size),
                        '\n              ',
                        this.tire_load_index && this.tire_speed_rating ? [
                            '\n                | ',
                            this.removeHTML(`${ this.tire_load_index }${ this.tire_speed_rating }`),
                            '\n              '
                        ] : null,
                        this.etail_warranty_distance ? [
                            _createElement('span', {
                                'className': 'bullet',
                                'key': '33041'
                            }, '\u2022'),
                            ' ',
                            this.etail_warranty_distance,
                            ' Mile Warranty\n              '
                        ] : null
                    ] : null), isStoreSelected && this.price ? [
                        scopePercentageDiscountInitialPriceDiscountInitialPrice2.apply(this, [
                            isTireProduct,
                            isStoreSelected,
                            isEconomyBrand
                        ]),
                        _createElement('p', {
                            'className': 'card__tax',
                            'key': '35313'
                        }, isEconomyBrand ? ['Brand may vary based on availability. '] : null, '\n              Price does not include tax, installation, or\n              ', _createElement('span', { 'className': 'card__tax-savings' }, 'Bonus Savings.'))
                    ] : null, !isStoreSelected ? _createElement('div', {
                        'className': 'login-for-pricing',
                        'key': '5069'
                    }, _createElement('span', {}, '\n              Select store to view pricing.\n              ', _createElement('a', {
                        'href': '/pages/locations',
                        'className': 'store-locator-modal'
                    }, 'Change Store'))) : null, [_createElement('ul', {
                            'className': 'titan-info-list',
                            'key': '53230'
                        }, this.availability_display_type === 'in_stock' ? _createElement('li', {
                            'className': 'titan-stock-info availability-message available',
                            'key': '5366'
                        }, [_createElement('svg', {
                                'width': '16',
                                'height': '16',
                                'viewBox': '0 0 16 16',
                                'xmlns': 'http://www.w3.org/2000/svg',
                                'key': '54950'
                            }, _createElement('path', {
                                'd': 'M3.5 8.5L6.5 11.5L12.5 5.5',
                                'fill': 'none',
                                'stroke': 'green',
                                'strokeWidth': '2.5',
                                'strokeLinecap': 'round',
                                'strokeLinejoin': 'round'
                            }))], _createElement('span', { 'className': 'titan-stock-info-status' }, _translate(`availability_in_stock`)), _createElement('div', { 'className': 'availability-message__separator' }, '|'), '\n    ', _translate(`availability_install_as_soon_as`), '\n    ', _createElement('span', {}, this.availability_date_text)) : null, this.availability_display_type === 'available' || this.availability_display_type === 'available_delayed' || this.availability_display_type === 'available_multi_day' || this.availability_display_type === 'available_in_3_days' ? _createElement('li', {
                            'className': 'titan-stock-info availability-message ' + (this.availability_display_type === 'available_multi_day' ? 'availability-message__latency-two' : this.availability_display_type === 'available_in_3_days' ? 'limited' : 'backordered'),
                            'key': '5998'
                        }, [_createElement('svg', {
                                'width': '16',
                                'height': '16',
                                'viewBox': '0 0 16 16',
                                'xmlns': 'http://www.w3.org/2000/svg',
                                'key': '65780'
                            }, _createElement('circle', {
                                'cx': '8',
                                'cy': '8',
                                'r': '4'
                            }))], '\n    ', _translate(`availability_available_as_soon_as`), '\n    ', _createElement('span', {}, this.availability_date_text)) : null, this.availability_display_type === 'available_delayed' || this.availability_display_type === 'available_multi_day' || this.availability_display_type === 'available_in_3_days' ? _createElement('li', {
                            'className': 'titan-stock-info availability-need-it-sooner',
                            'key': '6839'
                        }, _createElement('svg', {
                            'viewBox': '0 0 24 24',
                            'aria-hidden': 'true'
                        }, _createElement('circle', {
                            'cx': '12',
                            'cy': '12',
                            'r': '8.5'
                        }), _createElement('path', { 'd': 'M12 7v5l3 2' })), _createElement('span', {}, _translate(`availability_need_it_sooner`)), window.Convermax.selectedStorePhone ? [
                            '\n      ',
                            _translate(`availability_call_us_at`),
                            '\n      ',
                            _createElement('a', {
                                'href': `tel:${ window.Convermax.selectedStorePhone }`,
                                'key': '73181'
                            }, ' ', window.Convermax.selectedStorePhoneText, ' ')
                        ] : null) : null, this.availability_display_type === 'call_for_availability' ? _createElement('li', {
                            'className': 'titan-stock-info limited',
                            'key': '7566'
                        }, [_createElement('svg', {
                                'width': '16',
                                'height': '16',
                                'viewBox': '0 0 16 16',
                                'xmlns': 'http://www.w3.org/2000/svg',
                                'key': '76850'
                            }, _createElement('circle', {
                                'cx': '8',
                                'cy': '8',
                                'r': '4'
                            }))], _createElement('span', { 'className': 'titan-stock-info-status' }, _translate(`availability_call_for_availability`)), window.Convermax.selectedStorePhone ? [_createElement('a', {
                                'href': `tel:${ window.Convermax.selectedStorePhone }`,
                                'key': '79391'
                            }, ' ', window.Convermax.selectedStorePhoneText, ' ')] : null) : null, this.availability_display_type === 'available_at_store' ? _createElement('li', {
                            'className': 'titan-stock-info backordered',
                            'key': '8140'
                        }, [_createElement('svg', {
                                'width': '16',
                                'height': '16',
                                'viewBox': '0 0 16 16',
                                'xmlns': 'http://www.w3.org/2000/svg',
                                'key': '82600'
                            }, _createElement('path', {
                                'd': 'M3.5 8.5L6.5 11.5L12.5 5.5',
                                'fill': 'none',
                                'stroke': 'green',
                                'strokeWidth': '2.5',
                                'strokeLinecap': 'round',
                                'strokeLinejoin': 'round'
                            }))], _createElement('span', {}, _createElement('span', { 'className': 'titan-stock-info-status' }, '\n        ', _translate(`availability_available_at`), '\n        ', _createElement('a', {
                            'href': '/pages/locations',
                            'className': 'store-locator-modal'
                        }, ' ', window.Convermax.selectedStoreName, ' ')))) : null)]), this.bonus_savings ? _createElement('div', {
                        'className': 'pdp-deals-block',
                        'key': '8798'
                    }, _createElement('hr', {}), _createElement('div', { 'className': 'titan-deals-list' }, _createElement('span', {}, 'Buy 4+ Total and Unlock ', _createElement('span', { 'className': 'blue-text' }, 'Bonus Savings:')), _createElement.apply(this, [
                        'ul',
                        { 'className': 'titan-info-list' },
                        _map(this.discount_savings, repeatSaving3.bind(this, isTireProduct, isStoreSelected, isEconomyBrand)),
                        _map(this.bonus_savings, repeatSaving4.bind(this, isTireProduct, isStoreSelected, isEconomyBrand))
                    ]))) : null, isStoreSelected ? _createElement('div', {
                        'className': 'card__quick-add mob:card__quick-add--below desktop:card__quick-add--below',
                        'key': '9519'
                    }, this.availability_display_type !== 'call_for_availability' ? _createElement('convermax-product-form', { 'key': '9641' }, _createElement('div', {
                        'className': 'alert mb-8 bg-error-bg text-error-text js-form-error text-start',
                        'role': 'alert',
                        'hidden': true
                    }), _createElement('form', {
                        'method': 'post',
                        'action': '/cart/add',
                        'id': 'quick-add-' + this.id,
                        'acceptCharset': 'UTF-8',
                        'className': 'js-product-form',
                        'encType': 'multipart/form-data',
                        'noValidate': true,
                        'data-product-id': this.id
                    }, _createElement('input', {
                        'type': 'hidden',
                        'name': 'form_type',
                        'value': 'product'
                    }), _createElement('input', {
                        'type': 'hidden',
                        'name': 'utf8',
                        'value': '\u2713'
                    }), _createElement('input', {
                        'type': 'hidden',
                        'name': 'product-id',
                        'value': this.id
                    }), _createElement('input', {
                        'type': 'hidden',
                        'name': 'id',
                        'value': this.variant_ids
                    }), _createElement('input', {
                        'type': 'hidden',
                        'name': 'quantity',
                        'value': isOnStaggeredSearch ? 2 : 4
                    }), _createElement('div', { 'className': 'inline-block' }, _createElement('label', {
                        'className': 'label visually-hidden',
                        'htmlFor': 'quantity-template--' + this.id + '__main'
                    }, 'Qty'), _createElement('div', { 'className': 'qty-input qty-input--combined inline-flex items-center w-full' }, _createElement('button', {
                        'type': 'button',
                        'className': 'qty-input__btn btn btn--minus no-js-hidden',
                        'name': 'minus',
                        'onClick': e => window.Convermax.handleQtySelector(e.target, this.formatPrice)
                    }, _createElement('span', { 'className': 'visually-hidden' }, '-')), _createElement('input', {
                        'type': 'number',
                        'className': 'qty-input__input input',
                        'id': 'quantity-template--' + this.id + '__main',
                        'min': '1',
                        'max': '7',
                        'defaultValue': isOnStaggeredSearch ? 2 : 4,
                        'name': 'quantity',
                        'disabled': true
                    }), _createElement('button', {
                        'type': 'button',
                        'className': 'qty-input__btn btn btn--plus no-js-hidden',
                        'name': 'plus',
                        'onClick': e => window.Convermax.handleQtySelector(e.target, this.formatPrice)
                    }, _createElement('span', { 'className': 'visually-hidden' }, '+')))), _createElement('button', {
                        'onClick': onClick5.bind(this, isTireProduct, isStoreSelected, isEconomyBrand),
                        'className': 'btn add-to-cart-button btn--primary w-full',
                        'data-add-to-cart-text': 'Add to cart',
                        'name': 'add',
                        'aria-haspopup': 'dialog'
                    }, _createElement('span', { 'className': 'quick-add-btn-text' }, _translate(`product_add_to_cart`))))) : null, this.availability_display_type === 'call_for_availability' ? _createElement('a', {
                        'href': `tel:${ window.Convermax.selectedStorePhone }`,
                        'className': 'btn btn--primary w-full',
                        'key': '11866'
                    }, '\n            Call Store ', window.Convermax.selectedStorePhoneText, '\n          ') : null, [scopeProduct6.apply(this, [
                            isTireProduct,
                            isStoreSelected,
                            isEconomyBrand
                        ])]) : null))));
                }
                return scopeIsTireProductIsStoreSelectedIsEconomyBrand7.apply(this, []);
            }, { count: undefined })];
    }
    return _createElement('div', { 'className': 'cm_related-products' }, _createElement('div', { 'className': 'cm_related-products-title-container' }, _createElement('h2', { 'className': 'h4 mt-10 cm_related-products-title' }, _translate(`related_items_title`))), _createElement.apply(this, [
        'ul',
        { 'className': 'slider slider__grid grid grid-flow-col auto-cols-2 small-cards-mobile md:auto-cols-3 lg:auto-cols-4 xl:auto-cols-5 small-cards-desktop gap-x-theme gap-y-8 cm_related-products-list cmRepeater_items' },
        _map(this.items, repeatItems1.bind(this))
    ]));
}
        export const componentNames = []